import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { StringKey } from '../../../../lang/index';

/** A gray frame with an uppercase title over a white card — the room page's table panels. */
export const ActivitySection: FC<{
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  title: StringKey;
}> = ({ actions, children, className, title }) => (
  <section
    className={twMerge(
      'flex min-w-0 flex-1 flex-col gap-3 rounded-md bg-gray-50 px-0.5 pb-0.5 pt-3',
      className,
    )}
  >
    <div className="flex min-h-4 items-center justify-between gap-3 px-4">
      <h3 className="text-label-sm font-bold uppercase tracking-[1px] text-gray-700">
        <AppFormattedMessage id={title} />
      </h3>
      {actions}
    </div>
    <div className="flex flex-1 flex-col rounded-md bg-white p-1 shadow-sm">{children}</div>
  </section>
);
